export default "__VITE_ASSET__YtiEvSYc__"